import actionTypes from "../../actions/actionTypes";

const initialState = {
  triggerNotificationLoader: false,
  deleteNotificationLoader: false,
};

const engagementCenterReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case actionTypes.adminTypes.engagementCenter.TRIGGER_NOTIFICATION_LOADER:
      return {
        ...state,
        triggerNotificationLoader: payload,
      };
    case actionTypes.adminTypes.engagementCenter.DELETE_NOTIFICATION_LOADER:
      return {
        ...state,
        deleteNotificationLoader: payload,
      };
    default:
      return state;
  }
};

export default engagementCenterReducer;
